<template>
  <div class="app">
    <data-table
      :value="listArt"
      class="auction-table"
      responsive-layout="scroll"
      :paginator="true"
      :rows="100"
      :striped-rows="true"
      :sort-mode="'single'"
    >
      <template #header>
        <h2>Список артефактов</h2>
      </template>
      <column field="name" header="Название" sortable>
        <template #body="{ data }">
          <router-link :to="{ name: 'art', params: { id: data.id } }">{{ data.name }}</router-link>
        </template>
      </column>
    </data-table>
  </div>
</template>

<script setup lang="ts">
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import { listArt } from '@/common/list'
</script>

<style lang="scss">
body {
  background-color: #1e1e1e;
  color: #f0e6d2;
  font-family: 'Arial', sans-serif;
  margin: 0;
  padding: 0;
}

.app {
  padding: 20px;
}

.auction-table {
  margin: 20px auto;
  background-color: #2c2c2c;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

h2 {
  color: #f0e6d2;
  text-align: center;
  margin-bottom: 10px;
}
</style>
